export default "__VITE_PUBLIC_ASSET__9af157ca__"